// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1NKfn","rootSuccess":"CompleteLink_rootSuccess__2CKfN","rootFailure":"CompleteLink_rootFailure__3UZrN","isDisabled":"CompleteLink_isDisabled__PfYsb"};